(function () {
  if (window.Skins3for2Initialized) return;
  window.Skins3for2Initialized = true;

  const Skins3for2 = {
    cache: {},

    async getEligibleIds(collectionHandle) {
      if (!collectionHandle) return [];

      if (this.cache[collectionHandle]) {
        return this.cache[collectionHandle];
      }

      try {
        const response = await fetch(`/collections/${collectionHandle}?view=3for2-ids`, {
          credentials: 'same-origin'
        });

        if (!response.ok) throw new Error('Failed to load eligible product IDs');

        const data = await response.json();
        const ids = Array.isArray(data.product_ids) ? data.product_ids.map(Number) : [];
        this.cache[collectionHandle] = ids;
        return ids;
      } catch (error) {
        console.warn('Skins 3 for 2: could not fetch eligible IDs', error);
        return [];
      }
    },

    async getCart() {
      try {
        const response = await fetch('/cart.js', {
          credentials: 'same-origin'
        });

        if (!response.ok) throw new Error('Failed to load cart');

        return await response.json();
      } catch (error) {
        console.warn('Skins 3 for 2: could not fetch cart', error);
        return { items: [] };
      }
    },

    getEligibleQty(cart, eligibleIds) {
      if (!cart || !Array.isArray(cart.items)) return 0;

      return cart.items.reduce((total, item) => {
        return eligibleIds.includes(Number(item.product_id))
          ? total + Number(item.quantity || 0)
          : total;
      }, 0);
    },

    getMessage(eligibleQty) {
      const dealsUnlocked = Math.floor(eligibleQty / 3);
      const remainder = eligibleQty % 3;

      if (eligibleQty === 0) {
        return {
          state: 'default',
          text: '3 for 2 on selected products',
          subtext: 'Mix and match across eligible lines'
        };
      }

      if (remainder === 0) {
        if (dealsUnlocked === 1) {
          return {
            state: 'unlocked',
            text: 'You’ve unlocked 3 for 2',
            subtext: 'Add 3 more eligible products to unlock another offer'
          };
        }

        return {
          state: 'unlocked',
          text: `You’ve unlocked ${dealsUnlocked} x 3 for 2 deals`,
          subtext: 'Add 3 more eligible products to unlock another offer'
        };
      }

      const remaining = 3 - remainder;

      if (dealsUnlocked > 0) {
        return {
          state: 'progress',
          text: `Add ${remaining} more eligible product${remaining > 1 ? 's' : ''} to unlock another 3 for 2`,
          subtext: `${dealsUnlocked} offer${dealsUnlocked > 1 ? 's' : ''} already unlocked`
        };
      }

      return {
        state: 'progress',
        text: `Add ${remaining} more eligible product${remaining > 1 ? 's' : ''} to unlock 3 for 2`,
        subtext: 'Mix and match across eligible lines'
      };
    },

    async updateWidget(widget) {
      if (!widget) return;

      const collectionHandle = widget.dataset.collectionHandle || '3-for-2';
      const eligibleIds = await this.getEligibleIds(collectionHandle);
      const cart = await this.getCart();
      const eligibleQty = this.getEligibleQty(cart, eligibleIds);
      const message = this.getMessage(eligibleQty);

      const messageEl = widget.querySelector('[data-3for2-message]');
      const subtextEl = widget.querySelector('[data-3for2-subtext]');

      if (messageEl) messageEl.textContent = message.text;
      if (subtextEl) subtextEl.textContent = message.subtext || '';

      widget.setAttribute('data-3for2-state', message.state);
    },

    async updateAll() {
      const widgets = document.querySelectorAll('[data-3for2-widget]');
      if (!widgets.length) return;

      for (const widget of widgets) {
        await this.updateWidget(widget);
      }
    },

    initStickyBar() {
      const stickyBars = document.querySelectorAll('[data-3for2-sticky="true"]');
      if (!stickyBars.length) return;

      const onScroll = () => {
        const shouldStick = window.scrollY > 120;
        stickyBars.forEach((bar) => {
          bar.classList.toggle('is-stuck', shouldStick);
        });
      };

      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    },

    init() {
      this.updateAll();
      this.initStickyBar();
      window.addEventListener('pageshow', () => this.updateAll());
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      Skins3for2.init();
    });
  } else {
    Skins3for2.init();
  }
})();